import React, { useState } from 'react'
import emailjs from '@emailjs/browser';
import { IoBodyOutline, IoCallOutline, IoCarOutline, IoHandLeftOutline, IoHomeOutline, IoMedkitOutline, IoPeopleOutline, IoRestaurantOutline, IoRibbonOutline, IoShirtOutline, IoTimeOutline, IoWalkOutline, IoWaterOutline } from "react-icons/io5";

function Home() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipCode: '',
    message: 'Hello, Contacting you about your AllTime Home Care Services.',
    consent: true
  });

  const [status, setStatus] = useState({
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.message) {
      setStatus({
        message: 'Please fill in all required fields',
        isError: true
      });
      return;
    }

    try {
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: `Phone No: ${formData.phone}`,
        zip_code: `Zip Code: ${formData.zipCode}`,
        message: `Message: ${formData.message}`,
        consent: `Consent: ${formData.consent ? 'Client has consented for replies' : 'Did not Consent'}`
      };

      // Replace these with your actual EmailJS credentials
      await emailjs.send(
        'service_e24swfk',
        'template_s1ywwye',
        templateParams,
        'iO1sUlQqrICtJtYJd'
      );

      setStatus({
        message: 'Thank you for your message. We will get back to you soon!',
        isError: false
      });
      
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        message: '',
        consent: true
      });

    } catch (error) {
      setStatus({
        message: 'There was an error sending your message. Please try again.',
        isError: true
      });
    }
  };

  return (
    <div>
        <img src="./images/hero.jpeg" class="hero-image" alt="Services" />

      <div class="container-services">
        <div class="our-services">
            <h6>AllTime Home Care</h6>
            <h1>Our Services</h1>
            <p>
                AllTime Home Care offers a wide selection of in-home care services for seniors and adults living with disabilities. Our support isn’t a one-size-fits-all solution — we understand that every person’s situation is unique. That’s why each care plan is carefully customized to meet the specific needs of every individual. Whether it’s assistance with daily activities like dressing and personal hygiene, reminders to take medication, or safe transportation to medical visits, our compassionate caregivers are here to make life easier for you or your loved one.
            </p>
            <p>
                At AllTime Home Care, our dependable and caring team members are fully trained to handle a variety of care needs, ensuring exceptional service and comfort in any setting — whether at home, in an independent living community, an assisted living facility, or other environments.
            </p>
            <h6 style={{marginTop: '70px'}}>Compassionate Care You Can Trust</h6>
        </div>

        <form onSubmit={handleSubmit} class="contact-form-container">
              
          <div class='contact-form-header'>
            <IoCallOutline style={{fontSize: '40px', color: 'white'}} />
            <h3>Start Care Now<br /><span>816-799-6819</span></h3>
          </div>

          <input
            type="text"
            placeholder='First Name'
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder='Last Name'
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            placeholder='Phone Number'
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
          <input
            type="email"
            placeholder='Email'
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder='Zip Code'
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
          />

          <div class='checkbox-container'>
            <input
              type='checkbox'
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
            />
            <label for='consent'>
              By Checking this box and submitting this form  you are consenting to be contacted by SMS text messages. Message & data rates may apply. Messaging frequency may vary. You can reply stop to opt-out of further messaging. For assistance, text HELP.
            </label>
          </div>
          {status.message && (
            <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
              {status.message}
            </div>
          )}
          <button type='submit'>
            Submit
          </button>
        </form>


      </div>
      <div class='services-container'>

        <h1 class='services-title'>What we Can do for you</h1>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoBodyOutline size={32} class='icon-color'/>
            </div>
            <h3>Personal Care</h3>
            <p>AllTime Home Care provides gentle, respectful support with personal care needs such as bathing, grooming, dressing, and hygiene. Our caregivers focus on preserving dignity and comfort, ensuring that every individual looks and feels their best while maintaining independence in the familiarity of their home.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoRibbonOutline size={32} class='icon-color'/>
            </div>
            <h3>Alzheimer’s & Dementia Care</h3>
            <p>Caring for someone with Alzheimer’s or dementia requires understanding, patience, and specialized attention. Our caregivers receive thorough training to provide compassionate, person-centered care that supports memory, promotes safety, and encourages meaningful daily engagement — helping individuals live with confidence and comfort.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

        
        <div class='service-profile-container'>
          <img src="./images/care.jpeg" alt="Care" class='service-profile'/>
        </div>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoPeopleOutline size={32} class='icon-color'/>
            </div>
            <h3>Companion Care</h3>
            <p>Everyone needs companionship. Whether it’s sharing a conversation, enjoying a favorite activity, or going for a short walk, our caregivers help bring warmth and connection into each day. This service helps reduce loneliness and supports emotional well-being, keeping your loved one socially engaged and active.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoHandLeftOutline size={32} class='icon-color'/>
            </div>
            <h3>Assistance with Daily Activities</h3>
            <p>We assist clients with everyday activities that make life comfortable and independent. From organizing routines to offering a helping hand with daily tasks, our caregivers ensure that each person feels supported, capable, and secure in their environment.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

        <div class='service-profile-container'>
          <img src="./images/companioncare.jpeg" alt="Care" class='service-profile'/>
        </div>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoHomeOutline size={32} class='icon-color'/>
            </div>
            <h3>Light Housekeeping</h3>
            <p>A tidy, organized home contributes to peace of mind and well-being. Our team helps with light housekeeping duties such as cleaning, dusting, and general upkeep, allowing our clients to enjoy a safe, comfortable, and pleasant living space.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoShirtOutline size={32} class='icon-color'/>
            </div>
            <h3>Laundry Services</h3>
            <p>Our caregivers handle washing, drying, folding, and organizing clothes and linens with care. We ensure that your loved one always has clean, fresh garments and bedding — contributing to a clean and comfortable home environment.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

        <div class='service-profile-container'>
          <img src="./images/cleaning.jpg" alt="Care" class='service-profile'/>
        </div>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoWaterOutline size={32} class='icon-color'/>
            </div>
            <h3>Incontinence & Toileting Assistance</h3>
            <p>With respect and sensitivity, our caregivers provide discreet assistance for toileting and incontinence needs. We maintain the highest standards of privacy, dignity, and hygiene, ensuring comfort and confidence throughout the day.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoRestaurantOutline size={32} class='icon-color'/>
            </div>
            <h3>Meal Preparation</h3>
            <p>Nutrition plays a vital role in health and happiness. Our team plans and prepares balanced, tasty meals that meet dietary preferences and medical needs. From breakfast to dinner, we make sure every meal is both nourishing and enjoyable.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

        <div class='service-profile-container'>
          <img src="./images/mealpreparation.jpeg" alt="Care" class='service-profile'/>
        </div>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoCarOutline size={32} class='icon-color'/>
            </div>
            <h3>Errands & Transportation</h3>
            <p>Our caregivers offer safe, reliable transportation for appointments, shopping trips, and social outings. Whether it’s a visit to the doctor or a quick grocery run, we ensure clients stay active and connected to their community without the stress of travel.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoMedkitOutline size={32} class='icon-color'/>
            </div>
            <h3>Medication Reminders</h3>
            <p>Staying on schedule with medications is crucial for health and safety. We provide friendly, consistent reminders to help clients take their medications as prescribed, giving families peace of mind that their loved one’s care routine is being followed properly.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

        <div class='service-profile-container'>
          <img src="./images/meds.jpeg" alt="Care" class='service-profile'/>
        </div>

        <div class='services-list'>

          <div class='service-item'>
            <div class='service-icon'>
              <IoWalkOutline size={32} class='icon-color'/>
            </div>
            <h3>Mobility Assistance</h3>
            <p>Our caregivers assist with walking, transfers, and general movement to ensure safety and comfort. With patient support and attention to individual mobility levels, we help prevent falls and encourage continued activity and independence.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

          <div class='service-item'>
            <div class='service-icon'>
              <IoTimeOutline size={32} class='icon-color'/>
            </div>
            <h3>24/7 Care Services</h3>
            <p>We understand that care needs don’t stop at the end of the day. AllTime Home Care offers round-the-clock assistance, providing constant support, safety, and companionship — day and night — so clients and families can rest assured knowing help is always available.</p>
            <button class='contact-button'>Contact Us</button>
          </div>

        </div>

      </div>

      <div class='services-contact'>

        <div class='services-contact-item'>
          <h3>Already know what Services you need?</h3>
          <button class='first-button'>Connect with Us</button>
        </div>

        <div class='separator-container'>
          <div class='vertical-line'></div>
        </div>

        <div class='services-contact-item'>
          <h3>Not sure what types of care you need? Contact us for a consultation.</h3>
          <button class='second-button'>Get a Consultation</button>
        </div>

      </div>
    



    </div>
  )
}

export default Home